import { Component, OnInit, ElementRef } from "@angular/core";
import { DataService } from "../../../data.service";

@Component({
  selector: "lc-account-meeting-list",
  templateUrl: "./account-meeting-list.component.html",
  styleUrls: ["./account-meeting-list.component.scss"],
})
export class AccountMeetingListComponent implements OnInit {
  public my_meetings = [];
  public loading = false;
  public activeTab = "current";
  public show_past_meeting = true;
  constructor(public dataService: DataService) {}

  ngOnInit() {
    this.get_meetings();
  }

  get_meetings() {
    let yesterday = new Date();
    yesterday.setDate(yesterday.getDate() - 1);
    this.loading = true;
    this.dataService.get_meetings().subscribe(
      (data) => {
        this.my_meetings = [];
        for (let m of data) {
          if (new Date(m.start_time) <= yesterday) {
            m.is_past = true;
          } else {
            m.is_past = false;
          }
          if (!m.is_canceled) this.my_meetings.push(m);
        }
        this.loading = false;
        console.log(this.my_meetings);
      },
      (error) => {
        this.loading = false;
      }
    );
  }

  join_meeting(meeting, moderator) {
    let url: string;
    if (!!moderator) {
      url = meeting.moderator_link;
    } else {
      url = meeting.join_link;
    }
    if (!!meeting.is_active) {
      window.location.href = url;

      // the server does not allow CORS
      // this.dataService.http.get(url).subscribe(success=>{
      //   let info = success.json();
      //   debugger;
      //   //window.location.href = info
      // }, err=>{
      //   console.error(err);
      // });
    }
  }
}



// WEBPACK FOOTER //
// /Users/matthijs/projects/PHILIPS/philips-dental-pro/shop/src/app/components/account-management/account-meeting-list/account-meeting-list.component.ts